import { selectedResourcesByMasterIdSelector } from "../selectedResourcesByMasterIdSelector";
import { RootState } from "@/store/store";

export const selectedResourcesLengthByMasterIdSelector = (
  state: RootState,
  masterGridId: string,
) => {
  const resources = selectedResourcesByMasterIdSelector(state, masterGridId);

  return resources?.length;
};
